// Email validation utility - extracted from App.jsx
export const validateEmail = (email) => {
  if (!email || email.trim() === "") {
    return "Please enter your email address";
  }

  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

  if (!emailRegex.test(email)) {
    if (!email.includes("@")) {
      return "Please include an @ symbol";
    }
    if (email.indexOf("@") === 0) {
      return "Please enter text before the @";
    }
    if (email.indexOf("@") === email.length - 1) {
      return "Please enter a domain after the @";
    }
    if (!email.split("@")[1]?.includes(".")) {
      return "Please enter a valid domain (e.g. gmail.com)";
    }
    return "Please enter a valid email address";
  }

  return "";
};

// Additional validation utilities
export const isValidReferralCode = (code) => {
  return code && typeof code === 'string' && code.trim().length > 0;
};

export const sanitizeInput = (input) => {
  if (typeof input !== 'string') return '';
  return input.trim();
};